import React from "react";
import { Link } from "react-router-dom";
import {
  Bell,
  CircleHelp,
  Heart,
  History,
  LayoutDashboard,
  MessageSquareText,
  Scale,
  Settings,
  Sparkles,
  UsersRound,
  X,
} from "lucide-react";
import brandLogo from "../../assets/images/MySchoolMate.png";

export const dashboardNavItems = [
  { label: "Overview", to: "/dashboard/orang-tua", icon: LayoutDashboard, exact: true },
  { label: "Riwayat AI Match", to: "/dashboard/orang-tua/ai-match", icon: History },
  { label: "Sekolah Disukai", to: "/dashboard/orang-tua/likes", icon: Heart },
  { label: "Review Saya", to: "/dashboard/orang-tua/reviews", icon: MessageSquareText },
  { label: "Perbandingan", to: "/compare", icon: Scale },
  { label: "Profil Keluarga", to: "/dashboard/orang-tua/profil", icon: UsersRound },
  { label: "Notifikasi", to: "/dashboard/orang-tua/notifikasi", icon: Bell },
  { label: "Pengaturan", to: "/dashboard/orang-tua/pengaturan", icon: Settings },
  { label: "Bantuan", to: "/dashboard/orang-tua/bantuan", icon: CircleHelp },
];

export default function DashboardSidebar({ pathname, open, onClose, displayName }) {
  return (
    <>
      {open ? (
        <button
          type="button"
          className="fixed inset-0 z-40 bg-ink/25 lg:hidden"
          aria-label="Tutup menu dashboard"
          onClick={onClose}
        />
      ) : null}

      <aside
        className={`fixed inset-y-0 left-0 z-50 flex w-[260px] flex-col border-r border-ink/10 bg-white px-4 py-5 transition-transform duration-200 lg:sticky lg:top-0 lg:h-screen lg:translate-x-0 ${
          open ? "translate-x-0" : "-translate-x-full"
        }`}
        aria-label="Navigasi dashboard orang tua"
      >
        <div className="flex items-center justify-between gap-3 px-2">
          <Link to="/" className="rounded-lg focus-ring" aria-label="Kembali ke beranda MySchoolMate">
            <img src={brandLogo} alt="MySchoolMate" width="288" height="43" className="h-8 w-auto" />
          </Link>
          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 items-center justify-center rounded-xl text-ink hover:bg-cream focus-ring lg:hidden"
            aria-label="Tutup menu"
          >
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>

        <nav className="mt-8 flex-1 overflow-y-auto" aria-label="Menu dashboard">
          <ul className="space-y-1.5">
            {dashboardNavItems.map((item) => {
              const active = item.exact ? pathname === item.to : pathname.startsWith(item.to);
              const Icon = item.icon;
              return (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    onClick={onClose}
                    aria-current={active ? "page" : undefined}
                    className={`relative flex min-h-11 items-center gap-3 rounded-[14px] px-3.5 text-sm font-bold transition-colors focus-ring ${
                      active ? "bg-[#FFF3D7] text-ink" : "text-ink/62 hover:bg-cream hover:text-ink"
                    }`}
                  >
                    {active ? <span className="absolute left-0 h-6 w-1 rounded-r-full bg-[#F7AB2D]" aria-hidden="true" /> : null}
                    <Icon className={`h-[18px] w-[18px] ${active ? "text-[#C47B00]" : "text-ink/55"}`} aria-hidden="true" />
                    {item.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>

        <div className="mt-5 border-t border-ink/10 pt-5">
          <div className="flex items-center gap-3 rounded-[16px] bg-warm p-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-mint/25 font-extrabold text-ink">
              {(displayName || "Pengguna").charAt(0).toUpperCase()}
            </span>
            <div className="min-w-0">
              <p className="truncate text-sm font-extrabold text-ink">{displayName || "Pengguna"}</p>
              <p className="truncate text-xs font-medium text-ink/50">Orang Tua / Wali</p>
            </div>
            <Sparkles className="ml-auto h-4 w-4 shrink-0 text-[#F7AB2D]" aria-hidden="true" />
          </div>
        </div>
      </aside>
    </>
  );
}
